<template>
  <div class="modal" :class="{ active: true }">
    <OverlayProductHeader :title="product.title" :subTitle="product.subtitle" />
    <button class="close-button" @click="closeModal">&times;</button>
    <div class="modal-body">
      <div class="col">
        <ImgSlider :images="product.images" />
        <FileHandler :canDownloadAndPreviewFile="true" :fileList="product.documents" />
      </div>
      <div class="col">
        <OverlayProductInfoBox :infoText="product.details" :keyValues="keyValues" />
        <OverlayProductMetaInfoBox
          :createdDateString="product.createdDate"
          :lastModifiedDateString="product.lastModifiedDate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { SET_STATUS_ON_SHOW_OVERLAY_MODAL } from '@/store/mutation-types'
import OverlayProductInfoBox from './OverlayProductInfoBox.vue'
import OverlayProductMetaInfoBox from './OverlayProductMetaInfoBox.vue'
import OverlayProductHeader from './OverlayProductHeader.vue'
import ImgSlider from '@/components/general/slider/ImgSlider.vue'
import FileHandler from '@/components/general/files/FileHandler.vue'

export default {
  name: 'OverlayProduct',
  components: {
    OverlayProductInfoBox,
    OverlayProductMetaInfoBox,
    OverlayProductHeader,
    ImgSlider,
    FileHandler
  },
  props: {
    isOpen: {
      type: Boolean,
      deafult: false
    }
  },
  computed: {
    ...mapState({
      product: (state) => state.selectedPoiProduct
    }),
    imgSrc() {
      return this.product.images.length ? this.product.images[0].url : ''
    },
    keyValues() {
      return [
        {
          title: this.$t('general__text__brand'),
          value: this.product.brand.name
        },
        {
          title: this.$t('general__text__article-number'),
          value: this.product.externalId
        }
      ]
    }
  },
  methods: {
    ...mapMutations({
      toggleModal: SET_STATUS_ON_SHOW_OVERLAY_MODAL
    }),
    closeModal() {
      this.toggleModal({ toggleModal: false })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/variables.scss';

.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: 200ms ease-in-out;
  border-radius: 2px;
  z-index: 10;
  background-color: white;
  width: 800px;
  height: 520px;
  max-width: 90%;
  max-height: 80%;
}

.modal.active {
  transform: translate(-50%, -50%) scale(1);
}

.close-button {
  text-align: center;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
  font-size: 1.25rem;
  color: #fff;
  background-color: #16191c;
}

.modal-body {
  display: flex;
  padding: 20px;
  height: 100%;
  width: 100%;
}
.col {
  width: 50%;
  height: 100%;
  margin: 20px;
}
</style>
